module.exports = __webpack_public_path__ + "images/email-sent-3907cfeb.png";